import { updateCartData } from '@/lib/reducers/cartReducer'
import CommonModal from '../common/CommonModal'
import ActionButton from '../common/ActionButton'
import { dispatch, useSelector } from '@/lib/store'
import { initCouponDto, updateOrderData } from '@/lib/reducers/orderReducer'
import { usePathname, useRouter } from 'next/navigation'
import { HOME_PAGE } from '@/utils/constants'
import CART_HELPER from '@/helper/cartHelper'
import { useState } from 'react'
import { updateCityData } from '@/lib/reducers/cityReducer'
import { loadState, saveState } from '@/utils/localStorage'
import {
  deepClone,
  isCityProductRoute,
  isNonCityRoute,
  roundOff,
} from '@/utils/commonFunc'
import useCustomToast from '@/hooks/useCustomToast'

const CityChangeConfirmationModal = ({
  open,
  onOpenChange,
  setCheckoutStepCount,
  isInvokedFromCheckoutPage = false,
}: any) => {
  const router = useRouter()
  const pathname = usePathname()
  const showToast = useCustomToast()
  const loggedInMobileNumber = loadState('ctxVal') || null

  const { handleRestoreCartItems } = CART_HELPER()
  const cartState = useSelector((state) => state.cart) || {}
  const userState = useSelector((state) => state.user) || {}
  const orderState: any = useSelector((state) => state.order) || {}
  const cityState: any = useSelector((state) => state.city) || {}
  const commonState = useSelector((state) => state.common) || {}

  const [loading, setLoading] = useState(false)

  const handleResetLoyaltyAndCoupon = async (res: any) => {
    const deepCopyOrderState = deepClone(orderState)
    deepCopyOrderState.cartDtoList = res?.cartDtoList || []
    deepCopyOrderState.savingDto.couponDetailResponseDto = initCouponDto
    deepCopyOrderState.paymentDetailDto.couponDiscountAmount = 0

    deepCopyOrderState.savingDto.loyaltyDto.applied = false
    deepCopyOrderState.paymentDetailDto.clubAgilusAmount = 0
    deepCopyOrderState.savingDto.loyaltyDto.redeemedAmount = 0
    deepCopyOrderState.savingDto.loyaltyDto.redeemablePoints = 0

    let tempTotalAmount = roundOff(
      res?.totalAmount // no coupons when reseting the coupon n loyalty
    )
    deepCopyOrderState.paymentDetailDto.testCharges = tempTotalAmount
    deepCopyOrderState.paymentDetailDto.totalAmount = tempTotalAmount
    deepCopyOrderState.paymentDetailDto.amountPending = tempTotalAmount

    return deepCopyOrderState
  }

  const handleReviseCart = async () => {
    const isCityProductPage = isCityProductRoute(pathname)
    const isNonCityProductPage = isNonCityRoute(pathname)

    if (isCityProductPage || isNonCityProductPage) {
      const cityDataObj = cityState?.allCitiesList?.find(
        (item: any) => item?.uuid === commonState?.updatedCityUuid
      )
      const filteredCity = cityDataObj?.slugName
      const currentUrl = new URL(window.location.href)
      const pathSegments = currentUrl.pathname.split('/')
      if (isCityProductPage) {
        pathSegments[2] = filteredCity
      } else {
        pathSegments.splice(2, 0, filteredCity)
      }
      const updatedPath = pathSegments.join('/')
      router.push(updatedPath)
    }

    const cityUuid =
      isInvokedFromCheckoutPage && orderState?.addressDto?.cityUuid
        ? orderState.addressDto.cityUuid
        : commonState.updatedCityUuid
    setLoading(true)

    const res: any = await handleRestoreCartItems(
      userState?.phoneNumber,
      cityUuid
    )

    if (res?.status === true) {
      const updatedDeepCopyOrderState = await handleResetLoyaltyAndCoupon(
        res?.data
      )

      if (cityState?.allCitiesList?.length > 0) {
        const userSelectedCity: any = cityState.allCitiesList.find(
          (item: any) => item.uuid === cityUuid
        )
        if (userSelectedCity?.uuid) {
          dispatch(
            updateCityData({ ...cityState, currentCityObj: userSelectedCity })
          )
          saveState('city', userSelectedCity)
        } else {
          showToast('warning', 'Cart City is not servicable now.')
        }
      }

      dispatch(
        updateCartData({
          ...cartState,
          cartDtoList: res.data?.cartDtoList,
          cityUuid: res?.data?.cityUuid,
          totalAmount: res?.data?.totalAmount,
        })
      )
      dispatch(updateOrderData(updatedDeepCopyOrderState))
      if (isInvokedFromCheckoutPage) {
        const CART_ITEMS =
          res?.data?.cartDtoList.length > 0 ? res?.data?.cartDtoList[0] : []
        if (
          CART_ITEMS.length !== 0 &&
          CART_ITEMS?.productDtoList?.length !== 0
        ) {
          setCheckoutStepCount(1)
        } else {
          router.push(HOME_PAGE)
        }
      }
    }
    setLoading(false)
    onOpenChange()
  }

  return (
    <CommonModal open={open} onOpenChange={onOpenChange}>
      <div>
        <h2 className="text-heading-sm mb-2 text-center">
          Some tests might get removed
        </h2>
        <p className="text-label-xs text-gray-700 text-center mb-8 w-4/5 mx-auto">
          As you have changed the city, some test might not be available at your
          chosen location.
        </p>
        <div className="flex items-center gap-4 w-full justify-center">
          <ActionButton
            variant="secondary"
            title="Cancel"
            className="flex w-full text-label-lg font-semibold"
            onClick={onOpenChange}
          />
          <ActionButton
            variant="primary"
            title="Revise Cart"
            loading={loading}
            className="flex w-full text-label-lg font-semibold"
            onClick={handleReviseCart}
          />
        </div>
      </div>
    </CommonModal>
  )
}

export default CityChangeConfirmationModal
